import { GlobalAxios } from "../axios/axios-config";
import type { IReportRequest, IReportResult } from "../models/report.dto";

const REPORT_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Report";

const requestConfig = {
  paramsSerializer: { indexes: null },
};

export const getTicketsByClosureReason = async (params: IReportRequest) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/tickets-by-closure-reason",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getTicketsByChannelAndUserMonthly = async (
  params: IReportRequest,
) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/tickets-by-channel-and-user-monthly",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getTicketsByChannelAndUserDaily = async (params: IReportRequest) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/tickets-by-channel-and-user-daily",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getTicketsByAutomationInteraction = async (
  params: IReportRequest,
) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/tickets-by-automation-interaction",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getTicketsByAutomationFailure = async (params: IReportRequest) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/tickets-by-automation-failure",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getCrmMessagesByEstablishmentMonthly = async (
  params: IReportRequest,
) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/crm-messages-by-establishment-monthly",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getDigitalSignaturesByEstablishmentMonthly = async (
  params: IReportRequest,
) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/digital-signatures-by-establishment-monthly",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getDataBusRequestsByEstablishment = async (
  params: IReportRequest,
) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/data-bus-requests-by-establishment",
    {
      params,
      ...requestConfig,
    },
  );
};

export const getMostAccessedTicketServiceAreasMonthly = async (
  params: IReportRequest,
) => {
  return GlobalAxios.get<IReportResult>(
    REPORT_ROUTE + "/most-accessed-ticket-service-areas-monthly",
    {
      params,
      ...requestConfig,
    },
  );
};
